import { ListedInstrument, getInstrumentIdForce } from '@eih-netbroker/common';
import { useAtom } from 'jotai';
import { useMemo } from 'react';
import { useLocale } from '../../../../context/NbLocalizationContext';
import { useMarkets } from '../../../../shared/services/useMarkets';
import { ProductDetailsSectionItem } from '../../components/product/ProductDetailsSection';
import { productDetailstStateAtom } from '../../states/productDetailsStateAtom';
import { useProductDetailsCommon } from './useProductDetailsCommon';
import { ProductDetailsBaseVisibleFields } from './useProductDetailsListsForShare';

export const tradingFieldsAll: Array<keyof ProductDetailsBaseVisibleFields> = [
  'openPrice',
  'low',
  'high',
  'lastPrice',
  'lastPriceTime',
  'closePrice',
  'dailyChange',
  'dailyChangePercent',
  'annualLow',
  'annualLowDate',
  'annualHigh',
  'annualHighDate',
  'volumeQuantity',
  'volumeValue',
  'tenDayAverageVolume',
];

export const useProductDetailsListsForETF = (instrument: ListedInstrument | null, col: number) => {
  const [product] = useAtom(productDetailstStateAtom(instrument ? getInstrumentIdForce(instrument) : ''));
  const { translation } = useLocale();
  const { getTradingOrFundamentalSection, unknownValue, getInstrumentSection } = useProductDetailsCommon(instrument);
  const { getMicName } = useMarkets();

  const tradingFieldsForETF = useMemo(
    () => getTradingOrFundamentalSection(col, product, tradingFieldsAll),
    [col, product, getTradingOrFundamentalSection],
  );

  // TODO: is this an instrument too? general items doesnt match ListedInstrument properties
  const generalSectionItems: Array<ProductDetailsSectionItem> = useMemo(
    () => [
      {
        id: translation.productDetails.instrumentFields.name,
        label: translation.productDetails.instrumentFields.name,
        value: instrument ? instrument.instrumentName : unknownValue,
      },
      {
        id: translation.productDetails.instrumentFields.isin,
        label: translation.productDetails.instrumentFields.isin,
        value: instrument ? instrument.isin : unknownValue,
      },
      {
        id: translation.productDetails.instrumentFields.marketCode,
        label: translation.productDetails.instrumentFields.marketCode,
        value: instrument ? getMicName(instrument.mic) : unknownValue,
      },
      {
        id: translation.productDetails.instrumentFields.instrumentCategory,
        label: translation.productDetails.instrumentFields.instrumentCategory,
        value: instrument ? instrument.instrumentCategory : unknownValue,
      },
      {
        id: translation.productDetails.instrumentFields.currencyCode,
        label: translation.productDetails.instrumentFields.currencyCode,
        value: instrument ? instrument.currency : unknownValue,
      },
    ],
    [translation, instrument, unknownValue, getMicName],
  );

  const instrumentFieldsForETF = useMemo(
    () => getInstrumentSection(col, product, generalSectionItems),
    [col, product, getInstrumentSection, generalSectionItems],
  );

  return {
    tradingFieldsForETF,
    instrumentFieldsForETF,
  };
};
